export default __webpack_public_path__ + "static/media/icon-capture-screenshot.c9cf2bc9.svg";